import React from 'react';
import SelectRequestSource from '../containers/SelectRequestSource';
import RequestDestinationInfo from '../containers/RequestDestinationInfo';
import RequestStepInfo from './RequestStepInfo';
import RequestConfirmation from './RequestConfirmation';
import SelectRequestAttachments from '../containers/SelectRequestAttachments';
import { requestSteps } from '../constants';
import RequestWorkspaceInfo from '../workspaces/components/RequestWorkspaceInfo';

const wizardContent = {
  [requestSteps.SOURCE.name]: { component: SelectRequestSource },
  [requestSteps.DESTINATION.name]: { component: RequestDestinationInfo },
  [requestSteps.WORKSPACE.name]: { component: RequestWorkspaceInfo },
  [requestSteps.ATTACHMENTS.name]: { component: SelectRequestAttachments },
  [requestSteps.PROJECT.name]: { component: RequestStepInfo, section: 'project' },
  [requestSteps.ABOUT.name]: { component: RequestStepInfo, section: 'about' },
  [requestSteps.COMPLETE.name]: { component: RequestConfirmation },
};

const RequestAccessWizardContent = ({
  activeStep,
  category,
  code,
  compact,
}) => {
  const content = wizardContent[activeStep];
  const Component = content.component;

  return (<Component category={category} code={code} section={content.section} compact={compact} />);
};

export default RequestAccessWizardContent;
